import clsx from 'clsx';
import { StyledCountTab, StyledTab } from './style';
import { CustomTabsProps } from './types';

export const Tabs = ({
    size,
    className,
    items,
    children,
    type,
    classNameLabel = '',
    ...props
}: CustomTabsProps) => {
    return (
        <StyledTab
            size={size}
            indicator={{ align: 'center' }}
            items={items?.map((item) => ({
                ...item,
                label: (
                    <div className={clsx(`tab-label ${classNameLabel}`)}>
                        {item.label}
                        {item.count && (
                            <StyledCountTab className="tab-label-count">
                                {item.count}
                            </StyledCountTab>
                        )}
                    </div>
                ),
            }))}
            className={clsx(type === 'capsule' && 'capsule-tab', className)}
            {...props}
        />
    );
};
